const messages = {
    en: {
        account: {
            account_settings: 'Account settings',
            change_email: 'Change email',
            change_email_info: 'Type your new email address below.<br>We\'ll send an email to the new address requesting account verification.',
            delete_account: 'Delete account',
            delete_account_info: {
                header: 'This will permanently delete your account and your personal data.',
                body: 'Data that will be deleted includes:',
                list: [
                    'Your personal information',
                    'Applications to jobs within our system (not data that an employer may have downloaded)',
                    'Resumes, including from the employer candidate search',
                    'Marketing and job alert email subscriptions',
                ],
                footer: 'You will be able to create a new account afterwards.',
            },
            delete_confirmation: 'Are you sure? This cannot be reversed.',
            delete_success_title: 'Sorry to see you go :(',
            delete_success_message: 'Your account has been successfully deleted. We will now log you out.',
            enter_code: 'Enter code',
            resend_code: 'Click here to Resend code',
            reset_password: 'Reset password',
            reset_password_info: 'Click the button below and we\'ll email you a code to reset your password. You will then be prompted to create a new one!',
            reset_password_success: 'We have sent a reset code to your current email. Please make sure to also check your spam folder. Click here to Resend code.',
            try_again: 'Try Again in 10 minutes',
        },

        api_message: {
            UserTokenNotFoundException: 'It seems this token is invalid.',
            ValidationCaptchaException: 'It seems Google Captcha is invalid.',
            ValidationException: 'It seems some fields are invalid.',
            InvalidAuthenticationException: 'Check your email or password and try again.',
            MaxAttemptsException: 'Max attempts exceeded. ',
            ResourceNotFoundException: 'Request not found.',
            UserNotFoundException: 'User not found.',
            SeekerNotFoundException: 'We don\'t seem to recognise that email address. Please check and try again.',
            SeekerEmailResetNotFoundException: 'It seems your email is not found.',
            EmailTokenNotValidException: 'It seems this token is expired or invalid.',
            QueryException: 'Something went wrong.',
            ServerErrorException: 'Something went wrong.',
            UserConfirmationTokenNotFoundException: 'It seems this token is invalid.',
            UserExistsException: 'This email has already been taken.',
            JobNotFoundException: 'It seems this job is not available anymore.',
            UserResumeNotFoundException: 'It seems this resume does not exist anymore.',
            UserJobAlertNotFoundException: 'It seems this job alert does not exist anymore.',
            UserAppliedForJobException: 'It seems you already have applied for this job.',
            PromotionNotFoundException: 'It seems this promotion is not exist.',
            SmartfeedJobTokenNotFoundException: 'The apply token is not valid.',
            InvalidPasswordException: 'Your password is invalid.',
            OwnEmailNotAllowedException: 'You can not change to your current email.',
            FileImageSizeException: 'The image is too small. Min image size is 150x150px.',
            FileSizeException: 'The file size is too big. Max file size is 20MB',
            GoogleCaptchaException: 'Google captcha could not be validated.',
            SeekerPasswordResetNotFoundException: 'Re-enter the reset code and try again.',
            InvalidFilterCriteria: 'That\'s too broad. Please specify some criteria.',
            PasswordResetTooManyAttempts: 'Too many password reset attempts. Please try again in 20 seconds.',
            PasswordTokenNotValid: 'It seems this token is expired or invalid.',
        },

        additional_document: {
            drag_and_drop_info: 'Drag & drop or click <br> to upload additional documents',
            file_type_info: 'Only .docx, .doc, .pdf file is allowed',
            max_document_size_info: 'Max resume size is 10MB',
            not_found: 'No saved additional documents',
            remove: 'Remove additional document?',
            title: 'Additional documents',
            uploaded: 'Uploaded',
            uploaded_documents: 'Uploaded documents',
        },

        application: {
            title: 'Applications',
            not_found: 'No applications found',
            view: 'View job',
        },

        apply: {
            apply_with_email_title: 'Or apply with your email',
            apply_for_job: 'Apply for job',
            apply_as_guest: 'Applying as guest',
            info: 'We will automatically create a profile from the account you choose to apply with',
            apply_with_email: 'Applying with {email}',
            apply_with_linkedin: 'Applying with Linkedin',
            back: 'Back to job page',
            confirmation: 'A confirmation email has been sent to',
            job_application: 'Job Application',
            loading_resume: 'Loading your resume. Please wait..',
            success: 'Thank you for applying for this job',
            title: 'Apply with accounts',
            register_and_apply: 'Register and Apply',
            application_already_received: 'Application already received',
        },

        cover_letter: {
            add: 'Add cover letter',
            apply_without: 'Apply without cover letter',
            drag_and_drop_info: 'Drag & drop or click  to upload cover letter',
            edit: 'Edit cover letter',
            file_type_info: 'Only .docx, .doc, .pdf file is allowed',
            max_document_size_info: 'Max resume size is 10MB',
            not_found: 'No saved cover letters',
            remove: 'Remove cover letter?',
            title: 'Cover letter',
            uploaded: 'Uploaded',
            uploaded_documents: 'Uploaded cover letters',
            write_new: 'Write a new cover letter',
        },

        custom_form: {
            email_taken: 'This email is taken. Please <a href={value}>login</a> or <a href="/user-forgot-password/">reset your password</a>',
        },

        dashboard_menu: {
            applications: 'Applications',
            saved_jobs: 'Saved jobs',
            job_alerts: 'Job alerts',
            profile_details: 'Profile details',
            work_preferences: 'Work preferences',
            documents: 'Documents',
            account_settings: 'Account settings',
            logout: 'Logout',
        },

        filter: {
            clear_all: 'Clear all',
            info: 'User search above to find more',
            see_less: 'See less',
            see_all_value: 'See all {value} filters',
        },

        forgot_password: {
            title: 'Forgot password',
            info: 'Please enter your email address, and we\'ll send you a code to reset your password if account exists.',
            resend_code: 'Click here to Resend code',
            success: 'We have sent a reset code to the email below. Please make sure to also check your spam folder.',
            success_resend_code: 'We have sent a reset code to the email below. Please make sure to also check your spam folder.',
            try_again: 'Try again in {countDown} sec',
        },

        create_password: {
            title: 'Create password',
            info: 'Welcome back! It looks like your password has expired. We’ve emailed you a reset password pin. Please enter your pin and reset your password below.',
        },

        global: {
            currency_format: '${0}',
            currency_symbol: '$',
        },

        job_alert: {
            create: 'Create job alert',
            error: 'Can not create your job alert, please refresh and try again.',
            manage: 'Manage your job alerts',
            not_found: 'No saved job alert found',
            remove: 'Remove this saved job alert?',
            save: 'Save job alert',
            saved: 'Saved job alerts',
            search_term: 'Search term',
            success: 'Your job alert is created. Thank you',
            success_remove: 'Your job alert is removed. Thank you',
            title: 'Job alerts',
        },

        job_view: {
            date_posted: 'Date posted',
            expired: 'This job has expired',
            expired_desc: 'This job is no longer available. Please view our full list of jobs by clicking \'See more results\'.',
            posted_on: 'Posted on',
            see_desc: 'See job description',
            hide_desc: 'Hide job description',
            other_jobs: 'Similar jobs',
        },

        single_job: {
            backToSearchUrl: 'jobs',
            see_more_results: 'See more results',
            see_more_results_2: 'Back To All Jobs',
        },

        label: {
            add_all: 'Add all {value} of interest to you',
            add_value: 'Add {value}',
            additional_documents: 'Additional documents',
            alert_name: 'Alert name',
            alert_name_placeholder: 'Enter search name',
            already_have_account: 'Already have an account?',
            annual_salary: 'Annual Salary',
            annualy: 'Annually',
            any: 'Any',
            any_value: 'Any {value}',
            applied: 'Applied',
            apply_again: 'Apply again',
            apply_as_guest: 'Apply as guest',
            apply_now: 'Apply now',
            quick_apply: 'Quick Apply',
            availability: 'Availability',
            back: 'Back',
            back_to_value: 'Back to {value}',
            base_pay: 'Base pay',
            basic_information: 'Basic information',
            cancel: 'Cancel',
            career_level: 'Career level',
            certifications: 'Certifications',
            change_email: 'Change email',
            classification: 'Classification',
            classification_select: 'Select classifications from below',
            company: 'Company',
            company_placeholder: 'Enter the company name eg. ALDI',
            company_size: 'Company Size',
            confirm_password: 'Confirm password',
            confirm_remove: 'Yes, remove',
            consultant: 'Consultant',
            contact_number: 'Contact number',
            contact_number_placeholder: 'Enter contact number',
            continue_to_apply: 'Continue to apply',
            contract_type: 'Contract type | Contract types',
            country: 'Country',
            country_of_citizenship: 'Country of citizenship',
            course_name: 'Course name',
            cover_letter: 'Cover letter',
            cover_letter_custom_name: 'Enter a custom cover letter name',
            cover_letter_name: 'Cover letter name',
            cover_letters: 'Cover letters',
            create: 'Create',
            create_job_alert: 'Create job alert',
            create_password: 'Create password',
            current_role: 'Current role',
            daily: 'Daily',
            date_posted: 'Date posted',
            delete_my_account: 'Delete my account',
            description: 'Description',
            desired_occupations: 'Desired occupations',
            desired_pay: 'Desired pay',
            desired_work_locations: 'Desired work locations',
            dob: 'Date of birth',
            dont_have_account: 'Don\'t have an account?',
            download: 'Download',
            edit: 'Edit',
            edit_value: 'Edit {value}',
            education: 'Education',
            email: 'Email',
            email_address: 'Email address',
            email_address_placeholder: 'Enter email address',
            email_alert_frequency: 'Email alert frequency',
            email_me_code: 'Email me code',
            email_to: 'Email to',
            emergency_contact_name: 'Emergency contact name',
            emergency_contact_number: 'Emergency contact number',
            emergency_contact_rel: 'Emergency contact relationship',
            end_date: 'End date',
            enter_code: 'Enter code',
            enter_current_password: 'Enter current password',
            enter_current_password_for_email: 'Enter current password to verify email change',
            enter_new_email: 'Enter new email',
            enter_new_password: 'Enter new password',
            enter_the_value: 'Enter the {value}',
            enter_value: 'Enter {value}',
            enter_your_value: 'Enter your {value}',
            enter_your_value_again: 'Enter your {value} again',
            expires_at: 'Closing date',
            filters: 'Filters',
            find_jobs_now: 'Find jobs now',
            first_name: 'First name',
            first_name_placeholder: 'Enter first name',
            forgot_password: 'Forgot password',
            frequency: 'Frequency',
            gender: 'Gender',
            go: 'Set salary',
            home_location: 'Home location',
            hourly: 'Hourly',
            hourly_rate: 'Hourly rate',
            in_progress: 'In Progress',
            industries: 'Industries you are interested in working in',
            institution_name: 'Institution name',
            is_contactable: 'May we contact this referee?',
            is_report_directly: 'Did you report directly to this referee?',
            job_mode: 'Job mode',
            job_title: 'Job title',
            job_title_placeholder: 'Enter your job title eg. Accountant',
            job_type: 'Job type | Job types',
            job_type_placeholder: 'Select a job type',
            keyword: 'Keyword | Keywords',
            languages: 'Languages',
            last_name: 'Last name',
            last_name_placeholder: 'Enter last name',
            licenses_and_certifications: 'Licenses and Certifications',
            licenses_or_certifications: 'Licenses or Certifications',
            location: 'Location',
            login: 'Log in',
            look_for_all_jobs: 'Look for all available jobs',
            max: 'Max',
            message: 'Message',
            min: 'Min',
            mobile_number: 'Mobile number',
            mobile_number_placeholder: 'Enter mobile number',
            modified: 'Modified',
            new_cover_letter_details: 'New cover letter details',
            no_industries: 'I have no industry preference',
            no_job_mode: 'I have no job mode preference',
            not_added_value: 'No {value} added',
            not_found: 'Not found',
            null_pay_included: 'Include jobs that don\'t have salary details',
            occupation: 'Occupation',
            occupation_placeholder: 'Add all occupations of interest to you',
            off: 'Off',
            password: 'Password',
            payband_placehoder: 'Select the closest value',
            per_day: 'Per day',
            perks_and_benefits: 'Perks & benefits',
            phone_number: 'Phone number',
            phone_number_placeholder: 'Enter phone number',
            placeholder_email: 'email',
            placeholder_password: 'password',
            position: 'Position',
            position_placeholder: 'Enter position',
            print: 'Print',
            profession: 'Profession',
            profile_picture: 'Profile picture',
            qualification_type: 'Qualification type',
            range: 'Range',
            recover_password: 'Recover password',
            reference: 'Reference',
            reference_number: 'Reference number',
            register: 'Register',
            relevance: 'Relevance',
            remove: 'Remove',
            required_value: 'The {value} field is required',
            reset: 'Reset',
            reset_password: 'Reset password',
            resumes: 'Resumes',
            salary: 'Salary',
            salary_type: 'Salary type',
            salary_currency: 'Salary currency',
            salary_any_currency: 'Any currency',
            save: 'Save',
            save_cover_letter: 'Save cover letter',
            save_job: 'Save Job',
            save_value: 'Save {value}',
            save_work_experience: 'Save work experience',
            search_by_location: 'Search by suburb, city, or area',
            search_jobs: 'Search',
            search_keyword: 'Enter keyword',
            search_within_value: '`Search within {value1} {value2}',
            sector: 'Sector',
            select_location: 'All locations',
            select_value: 'Select {value}',
            share: 'Share',
            sign_in: 'Sign in',
            sign_in_and_apply: 'Sign in and apply',
            skills: 'Skills',
            sort_by: 'Sort by',
            start_date: 'Start date',
            start_end_dates: 'Start and end dates',
            sub_classification: 'Sub classification',
            sub_classification_select: 'Select subclassifications',
            submit: 'Submit',
            suburb_city_area: 'suburb, city, or area',
            unsave: 'Unsave',
            upload_file_size: 'File size 10MB max',
            upload_label: 'Tap to upload document',
            upload_new: 'Upload new',
            upload_new_additional_document: 'Upload new additional document',
            upload_new_cover_letter: 'Upload new cover letter',
            upload_new_resume: 'Upload new resume',
            upload_profile_picture: 'Upload profile picture',
            uploaded: 'Uploaded',
            uploaded_document: 'Uploaded document',
            uploaded_now: 'just now',
            view_job: 'View job',
            weekly: 'Weekly',
            what_is_this: 'What is this',
            what_is_this_occupation: 'This occupation will be used to tailor your job recommendations. Please select the occupation that best relates to the role job title.',
            work_authorisation: 'Work authorisation',
            work_experience: 'Work experience',
            work_location: 'Work location',
            work_occupation_placeholder: 'Enter your job occupation',
            work_preferences: 'Work preferences',
            work_type: 'Work type',
            write_a_cover_letter: 'Write a cover letter',
            write_cover_letter: 'Write cover letter',
            just_posted: 'Just posted!',
            new: 'New',
        },

        login: {
            welcome_back: 'Welcome back',
            welcome: 'Welcome!',
            title: 'Log in',
            info: '',
            back: 'Back to log in',
        },

        profile: {
            basic_information: 'Basic information',
            not_found_location: 'We do not currently support job listings in this location. Please contact us to request a new location.',
            not_found_global_location: 'No matching locations found. Please try a different search or select the Country as the location.',
            pay_info: 'Your pay information helps us to better understand your career history, so we can focus on progressing your career.',
            profile_details: 'Profile details',
        },

        register: {
            welcome: 'Welcome',
            welcome_aboard: 'Welcome aboard!',
            info: '',
            back: 'Back to register',
        },

        reset_email: {
            title: 'Reset email',
            success: 'Your email has been reset',
        },

        reset_password: {
            title: 'Create password',
            info: 'Please enter your account email address and new password.',
            success: 'You\'ve successfully created a new password!',
        },

        resume: {
            apply_without: 'Apply without a resume',
            default: 'Default resume',
            dropbox_title: 'Upload via Dropbox',
            default_option: 'Set as default for future applies',
            default_text: 'Select resume option',
            drag_and_drop_info: 'Drag & drop or click <br> to upload resume',
            drag_and_drop_size: '(Filesize 10MB max)',
            file_type_info: 'Only pdf, docx, doc, rtf, txt, odt, pages (10MB max)',
            googledrive_title: 'Upload via Google Drive',
            max_resume_size_info: 'Max resume size is 10MB',
            new: 'Upload new resume',
            not_found: 'No resumes uploaded',
            remove: 'Remove resume?',
            title: 'Resumes',
            upload_documents: 'Upload documents',
            upload: 'Upload resumes',
            uploaded: 'Uploaded',
            uploaded_resumes: 'Select resume',
            upload_via: 'Upload via {service}',
            ducment_uploaded: 'Document uploaded',
        },

        saved_job: {
            saved_jobs: 'Saved jobs',
            not_found: 'No saved jobs found',
        },

        search_results: {
            not_found: 'Sorry, we don\'t currently have any jobs matching your search criteria. Click the button above to add a job alert based on your search and we\'ll let you know as soon as there\'s a job available.',
            showing: 'Showing',
            separator: 'to',
            of: 'of',
            results: 'results',
            listView: 'List View',
            mapView: 'Map View',
            mapViewLocation: 'Location',
            mapViewRadius: 'Within (KM)',
            mapViewUpdate: 'Update Map',
            mapViewReset: 'Reset Map',
        },

        share: {
            facebook: 'Post',
            linkedin: 'Share',
            title: 'Share via',
            twitter: 'Tweet',
        },

        terms: {
            link: 'By continuing with the application, you agree to our',
            terms: 'Terms of Use',
            and: 'and',
            privacy: 'Privacy Policy',
            validation_message: 'Please agree to our terms and conditions',
        },

        work_preferences: {
            work_preferences: 'Work Preferences',
            next_role: 'Your next role',
            other: 'Other preferences',
            job_type: 'Job Type',
            contract_type: 'Contract Type',
        },

        work_experience: {
            add: 'Add work experience?',
            edit: 'Edit work experience?',
            remove: 'Remove work experience',
        },

        education: {
            add: 'Add education',
            remove: 'Remove education',
        },

        reference: {
            add: 'Add referee',
            remove: 'Remove referee',
        },

        screening: {
            confirm_and_finish: 'Confirm and finish',
            title: 'Complete additional questions',
            sub_title: 'Improve your chances of being considered for this job by completing the below questions',
        },

        searchbar: {
            keywords_label: 'Keywords',
            classifications_label: 'Classifications',
            classification_placeholder: 'in all classifications',
            locations_label: 'Location',
        },

        networks: {
            facebook: {
                shareText: 'Post',
            },
            twitter: {
                shareText: 'Tweet',
            },
            linkedin: {
                shareText: 'Share',
            },
        },
    },
};

export default messages;
